import { Component } from '@angular/core';

@Component({
  selector: 'app-whitecollar',
  templateUrl: './whitecollar.component.html',
  styleUrls: ['./whitecollar.component.css']
})
export class WhitecollarComponent {
  ShowCard:any
}
